import { ReactNode } from 'react';
import Box, { IBoxProps } from '../../../Box';
import Panel from '../../../Panel';

interface IBreadcrumbsContainerProps extends IBoxProps {
  children: ReactNode;
}

const BreadcrumbsContainer = (props: IBreadcrumbsContainerProps) => {
  const { children, ...restProps } = props;
  return (
    <Panel>
      <Box px={3} py={1.5} height={40} display="flex" alignItems="center" {...restProps}>
        {children}
      </Box>
    </Panel>
  );
};

export default BreadcrumbsContainer;
